import React, { useContext } from 'react'
import PrivateRoute from './PrivateRoute'
import { Navigate, Route, Routes } from 'react-router'
import { useNavigate } from 'react-router-dom'
import IdleTimer from 'react-idle-timer'
import HomePage from '../../pages/homePage/HomePage'
import UserPage from '../../pages/userPage/UserPage'
import CallbackPage from '../../pages/callbackPage/CallbackPage'
import SupportPage from '../../pages/supportPage/SupportPage'
import ErrorPage from '../../pages/errorPage/ErrorPage'
import LogoutPage from '../../pages/logoutPage/LogoutPage'
import LogoutCallbackPage from '../../pages/logoutCallbackPage/LogoutCallbackPage'
import SignicatCallbackPage from '../../pages/signicatCallbackPage/SignicatCallbackPage'
import { idleTimerService, NotFoundPage, IdleTimeOutModal } from 'exports'
import AuthContext from 'contexts/auth'
import { appRoutes } from 'constants/routes/Routes'
import { MaintenanceContextProvider } from 'contexts/MaintenanceContext'
import LoginPage from 'pages/loginPages/LoginPage'
import EParakstsCallbackPage from '../../pages/eParakstsCallbackPage/EParakstsCallbackPage'
import BankIdCallbackPage from 'pages/bankIdCallbackPage/BankIdCallbackPage'
import NorwegianBankIdCallbackPage from '../../containers/NorwegianBankIdCallbackPage'

interface ITimer {
	timeout: number
	showModal: boolean
	userLoggedIn: boolean
	isTimedOut: boolean
	counter: any
}

function RootRoute({ history }: any) {
	const navigate = useNavigate()
	const [timer, setTimer] = React.useState<ITimer>({
		timeout: 60000 * 15 * 1, //15 minutes
		showModal: false,
		userLoggedIn: false,
		isTimedOut: false,
		counter: 60, //seconds
	})

	const idleTimer = React.useRef<IdleTimer>(new IdleTimer(timer))
	// console.log('idleTimer idleTimer idleTimer ', idleTimer)
	const { isAuthenticated } = useContext(AuthContext)

	return (
		<>
			{isAuthenticated ? (
				<IdleTimer
					ref={idleTimer as any}
					onActive={() => idleTimerService.onActive}
					onAction={() => idleTimerService.onAction}
					onIdle={() => idleTimerService.onIdle(setTimer, timer)}
					element={document}
					debounce={250}
					timeout={timer.timeout}
					stopOnIdle={true}
				/>
			) : (
				<></>
			)}
			<Routes>
				<Route
					path={appRoutes.login}
					element={
						isAuthenticated ? (
							<Navigate to={appRoutes.homePage} />
						) : (
							<LoginPage />
						)
					}
				/>
				<Route path={appRoutes.logout} element={<LogoutPage />} />
				<Route
					path={appRoutes.startpage}
					element={
						isAuthenticated ? (
							<Navigate replace to={appRoutes.homePage} />
						) : (
							<LoginPage />
						)
					}
				/>
				<Route path={appRoutes.errorPage} element={<ErrorPage />} />
				<Route
					path={appRoutes.callbackPage}
					element={<CallbackPage />}
				/>
				<Route
					path={appRoutes.signicatCallback}
					element={<SignicatCallbackPage />}
				/>
				<Route
					path={appRoutes.logoutCallback}
					element={<LogoutCallbackPage />}
				/>
				<Route
					path={appRoutes.norwegianBankIdCallback}
					element={<NorwegianBankIdCallbackPage />}
				/>
				<Route
					path={appRoutes.homePage}
					element={
						<PrivateRoute
							redirect={appRoutes.login}
							component={HomePage}
							path={appRoutes.homePage}
						/>
					}
				/>
				<Route
					path={appRoutes.userPage}
					element={
						<PrivateRoute
							redirect={appRoutes.login}
							path={appRoutes.userPage}
							component={UserPage}
						/>
					}
				/>
				<Route
					path={appRoutes.supportPage}
					element={
						<PrivateRoute
							redirect={appRoutes.login}
							path={appRoutes.supportPage}
							component={SupportPage}
						/>
					}
				/>
				<Route
					path={appRoutes.eParakstsCallback}
					element={<EParakstsCallbackPage />}
				/>
				<Route
					path={appRoutes.bankIdCallbackPage}
					element={<BankIdCallbackPage />}
				/>
				{/* //Default route*/}
				<Route element={NotFoundPage} />
			</Routes>

			<IdleTimeOutModal
				showModal={timer.showModal}
				handleClose={() =>
					idleTimerService.handleClose(idleTimer, setTimer)
				}
				handleLogout={() =>
					idleTimerService.handleLogout(navigate, setTimer)
				}
				remainingTime={timer.counter}
			/>
			{isAuthenticated ? (
				<div className="authMaintenance">
					<MaintenanceContextProvider />
				</div>
			) : (
				<div className="nonAuthMaintenance">
					<MaintenanceContextProvider />
				</div>
			)}
		</>
	)
}
export default RootRoute
